import { useTranslation } from "react-i18next";
import React from "react";
import AboutChatbotCard from "./AboutChatbotCard";
import EficienciaIMG from "../../assets/app/AboutChatbotSection/EFICIENCIA.png";
import DisponibilidadIMG from "../../assets/app/AboutChatbotSection/24-HORAS.png";
import AhorrosIMG from "../../assets/app/AboutChatbotSection/AHORROS.png";
import "../../styles/app/AboutChatbotSection.css";

const AboutChatbotSection: React.FC = () => {
  const { t } = useTranslation();
  const props = [
    {
      src: EficienciaIMG,
      title: t("aboutChatbot.cards.0.title"),
      desc: t("aboutChatbot.cards.0.description"),
    },
    {
      src: DisponibilidadIMG,
      title: t("aboutChatbot.cards.1.title"),
      desc: t("aboutChatbot.cards.1.description"),
    },
    {
      src: AhorrosIMG,
      title: t("aboutChatbot.cards.2.title"),
      desc: t("aboutChatbot.cards.2.description"),
    },
  ];
  return (
    <>
      <section className="about-cb-section">
        <div className="about-cb-heading">
          <h1 className="about-cb-title">{t("aboutChatbot.title")}</h1>
          <p className="about-cb-desc">{t("aboutChatbot.description")}</p>
        </div>
        <div className="about-cb-grid">
          {props.map((p, index) => (
            <AboutChatbotCard
              key={index}
              src={p.src}
              title={p.title}
              desc={p.desc}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default AboutChatbotSection;
